import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import GuiaDocente from "../../../components/GuiaDocente";

import Imagen3 from "../../../images/modulo12/dnidelante.png";
import Imagen4 from "../../../images/modulo12/dniatras.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad1Actividad9.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo12.content[0];
  const infoAct = modulo12.content[0].activities[11];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titlePrev: `${modulo12.content[0].name}: ${modulo12.content[0].activities[10].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[10].path}`,
    titleNext: `${modulo12.content[0].name}: ${modulo12.content[0].activities[12].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[12].path}`,
  };

  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul className="mb-4">
            <li>
              Reniec es la oficina que le da su DNI a toda la población. Imagina
              que trabajas ahí y que debes entregarle su DNI a un amigo o amiga.
            </li>
            <li>
              Lee la información de la encuesta que hiciste en la Actividad 6.
            </li>
            <li>
              Completa el DNI del amigo, amiga o familiar a quien encuestaste.
            </li>
            <li>
              Pídele que te dé los datos que faltan para completar su DNI.
            </li>
          </ul>
        </div>
        <div className="col-lg-10 col-12">
          <img src={Imagen3} alt="Electores" className="img-fluid" />
        </div>
        <div className="col-lg-10 col-12">
          <img src={Imagen4} alt="Electores" className="img-fluid" />
        </div>
        <div className="col-lg-10 col-12">
          <ul className="mt-4">
            <li>
              ¿Qué diferencias y semejanzas encuentras entre tu DNI y el de tus
              amigos, amigas o familiares? Conversen al respecto.
            </li>
          </ul>
          <div>
            <p>
              ¿Hay algunos nombres o apellidos iguales o todos son diferentes?
            </p>
            <textarea className="form-control mb-3" rows={3} />
            <p>¿Hemos nacido en muchos lugares diferentes?</p>
            <textarea className="form-control mb-3" rows={3} />
            <p>¿Hay familias con el mismo lugar de origen?</p>
            <textarea className="form-control mb-3" rows={3} />
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea las siguientes indicaciones: Completa el DNI de un amigo, amiga
            o familiar a quien encuestaste. No olvides dibujar su “foto”.
          </li>

          <li>
            Pídele al amigo, amiga o familiar que escogiste que te dé los datos
            que faltan para completar su DNI.
          </li>

          <li>
            Asegúrese de que los datos están completos para poder realizar la
            siguiente parte de la actividad.
          </li>

          <li>
            En ella se conversará acerca de los resultados de las actividades
            anteriores.
          </li>

          <li>
            Intercambien opiniones entre todos teniendo en cuenta las preguntas
            que aparecen en las indicaciones: ¿Qué diferencias y semejanzas
            encuentras entre tu DNI y el de tus amigos, amigas o familiares?
            Conversen al respecto.
          </li>

          <li>
            ¿Hay algunos nombres o apellidos iguales o todos son diferentes?
            ¿Hemos nacido en muchos lugares diferentes? ¿Hay familias con el
            mismo lugar de origen?
          </li>

          <li>
            Luego, resalte las semejanzas y las diferencias. Puede, por ejemplo,
            utilizar estas preguntas para guiar la conversación:
            <ul>
              <li>
                <i>
                  “¿Qué apellidos comunes tenemos entre los compañeros de la
                  clase? ¿Quiénes han nacido fuera de nuestra ciudad, provincia
                  o región? ¿De dónde vienen nuestros padres y madres?”
                </i>
              </li>
            </ul>
          </li>

          <li>
            Cierre la actividad destacando de manera positiva la diversidad
            encontrada.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
